import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "lib-flexible";
Vue.config.productionTip = false;
import Vant from "vant";
import "vant/lib/index.css";
import draggable from 'vuedraggable' 
Vue.use(draggable)
Vue.prototype.toBack = () => window.android.finish(); //router.go(-1);
Vue.use(Vant);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
